__turbopack_context__.v({
  "arrow": "Row-module-scss-module__LgnvIG__arrow",
  "item": "Row-module-scss-module__LgnvIG__item",
});
